<!-- Create/activate a new account -->

<div class="fullscreen" >
    <div class="row justify-content-center m-0 auth-box mt-2">
        <div class="col-sm-4 p-0">

            <!-- Logo-->
            <mat-card class="p-0">
                <div class="d-flex justify-content-center pt-3">
                    <div class="logo-wrapper">
                        <img class="logo-img w-100" src="{{service.V.config.host + '/4dinfo/image.png'}}">
                    </div>
                </div>

                <!-- Activate your account message-->
                <div class="d-flex justify-content-center">
                        <h3 class="text-center mt-4">{{ 'SIGNIN.ACTIVATE' | translate }}</h3>
                </div>

                 <!-- Activate your account progress bar-->
                <mat-card-content class="p-4 text-center" *ngIf="(!error && !user) || loading">
                    <mat-progress-bar mode="indeterminate" ></mat-progress-bar>
                </mat-card-content>

                <ng-container  *ngIf="user">
                <mat-card-content class="p-4 text-center">

                    <!-- 'You have been invited to join {{ account }}'' message -->
                    <div  class="mb-2" *ngIf="user.accountUid">{{ 'SIGNIN.JOIN_DETAILS' | translate:{account:user.accountName} }}</div>
                    
                    <!-- 'To complete your set up, please fill out all form fields below' message -->
                    <div *ngIf="!user.active" class="mb-2" translate>SIGNIN.FINISH_DETAILS</div>
                    
                    <!-- Error message-->
                    <div  *ngIf="error" class="mt-2 mb-2 text-danger"><fa-icon icon="exclamation-triangle"></fa-icon>{{ 'ERROR.' +  error.status | translate }}</div>
                    <ng-container *ngIf="!user.active">
                    
                        <div class="row">
                        
                            <!-- First name -->
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <mat-icon matPrefix class="mr-2">account_box</mat-icon>
                                    <input matInput #uname="ngModel" type="text" name="uname" placeholder="{{'SIGNIN.F_NAME_PLACEHOLDER' | translate }}" [(ngModel)]="user.first_name" required >
                                </mat-form-field>    
                            </div>
                            
                            <!-- Last name -->
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <input matInput #uname="ngModel" type="text" name="uname" placeholder="{{'SIGNIN.L_NAME_PLACEHOLDER' | translate }}" [(ngModel)]="user.last_name" required >
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Email address -->
                        <mat-form-field class="w-100">
                            <mat-icon matPrefix class="mr-2">email</mat-icon>
                            <input matInput #email="ngModel" type="text" name="username" placeholder="{{'SIGNIN.EMAIL' | translate }}" [ngModel]="user.username" disabled >
                        </mat-form-field>

            
                        <div class="row">

                            <!-- Password -->
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                    <mat-icon matPrefix class="mr-2">lock</mat-icon>
                                    <input matInput #pass="ngModel" type="password" name="password" placeholder="{{'SIGNIN.PASS' | translate }}" [(ngModel)]="user.password" required >
                                    <mat-hint>{{ 'SIGNIN.PASSWORD_LENGTH' | translate }}</mat-hint>
                                </mat-form-field>      
                            </div>

                            <!-- Confirm password -->
                            <div class="col-6">
                                <mat-form-field class="w-100">
                                     <input matInput #pass="ngModel" type="password" name="password2" placeholder="{{'SIGNIN.PASS_CONFIRMATION' | translate }}" [(ngModel)]="password2" required >
                                     <mat-hint class="text-danger" *ngIf="user.password && user.password != password2" >{{ 'SIGNIN.ERROR.MATCH_PASS' | translate }} </mat-hint>
                                </mat-form-field>
                            </div>
                        </div>

                    <!-- Team/company account name -->
                    <mat-form-field class="w-100" *ngIf="!user.account">
                        <mat-icon matPrefix class="mr-2">account_box</mat-icon>
                        <input matInput #aname="ngModel" type="text" name="aname" placeholder="{{'SIGNIN.ACC_NAME_PLACEHOLDER' | translate }}" [(ngModel)]="user.accountName" required >
                    </mat-form-field>

                    <!-- Terms and conditions link and check box -->
                    <div class="mt-2 mb-2 text-center">
                        <mat-checkbox [(ngModel)]="terms">{{ 'SIGNIN.TERMS' | translate }}</mat-checkbox><br/>
                        <a class="ml-4" target="_new"  href="{{ 'SIGNIN.TERMS_link' | translate }}">{{ 'SIGNIN.TERMS_link_text' | translate }}</a>  
                    </div>

                    <!-- Activate new account button -->
                        <button (click)="activate()" mat-raised-button color="primary" type="submit" class="w-100 m-0" [disabled]="loading || !terms || (!user.accountName && !user.account) || !user.first_name || !user.last_name  || email.invalid || pass.invalid || (aname?.invalid && !user.accountUid) || password2 != user.password">{{ 'SIGNIN.ACTIVATE_BTN' | translate }}</button>
                    </ng-container>
                    <ng-container *ngIf="user.active">
                            <button (click)="activate()" mat-raised-button color="primary" type="submit" class="w-100 m-0" [disabled]="loading">{{ 'SIGNIN.JOIN_BTN' | translate }} {{user.account }}</button>
                    </ng-container>
                </mat-card-content>
                <!--<mat-card-actions class="m-0 p-4"> </mat-card-actions -->
                </ng-container>

                 <!-- Error message -->
                <mat-card-content class="p-4 text-center" *ngIf="!user && error">
                    <fa-icon icon="exclamation-triangle" size="4x" class="text-danger"></fa-icon>
                    <div translate class="mt-2 mb-2">ERROR.{{ error.status }}</div>
                </mat-card-content>

            </mat-card>
        </div>
    </div>
</div>
